import { render, staticRenderFns } from "./timebox_status_badge.vue.js?vue&type=template&id=536accd5&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./timebox_status_badge.vue?vue&type=template&id=536accd5&vue3"
import script from "./timebox_status_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./timebox_status_badge.vue?vue&type=script&lang=js&vue3"
export * from "./timebox_status_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./timebox_status_badge.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports